import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DialogConfirmation } from '../../../../../../components/dialog/confirmation';
import { ROUTES } from '../../../../../../routes/routes';

type UpdateDevicesDialogProps = {
  showDialog: boolean;
  setShowDialog: (show: boolean) => void;
  handleSaveDevicesMemoryForInstallationId: () => void;
};

export const UpdateDevicesDialog: React.FC<UpdateDevicesDialogProps> = ({
  showDialog,
  setShowDialog,
  handleSaveDevicesMemoryForInstallationId,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation('device-list');
  const { t: tc } = useTranslation('common');

  const handleClose = () => {
    handleSaveDevicesMemoryForInstallationId();
    setShowDialog(false);
  };

  const handleAction = () => {
    handleClose();
    navigate(ROUTES.Device());
  };

  return (
    <DialogConfirmation
      show={showDialog}
      setShow={handleClose}
      header={t('updateDevicesInfo.header')}
      content={t('updateDevicesInfo.content')}
      primaryBtnText={tc('buttons.continue')}
      secondaryBtnText={tc('buttons.cancel')}
      primaryBtnAction={handleAction}
      secondaryBtnAction={handleClose}
      timerCancel
    />
  );
};
